import { render, staticRenderFns } from "./VerifyStatus.vue?vue&type=template&id=d8990aea&"
import script from "./VerifyStatus.vue?vue&type=script&lang=js&"
export * from "./VerifyStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports